import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import user from "./slices/userSlice";
import cache from "./slices/cacheSlice";

const rootReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		theme,
		auth,
		user,
		cache,
		...asyncReducers,
	});
	return combinedReducer(state, action);
};

export default rootReducer;
